import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../store/hooks';
import { logout } from '../store/slices/authslice';
import { ChevronDown } from 'lucide-react';
import axios from 'axios';
import { endpoints } from '../api/api';
import { trackLogout } from '../utils/analytics';

const AppHeader = () => {
  const { user } = useAppSelector((state) => state.auth);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    const refreshToken = localStorage.getItem('refreshToken');

    axios.post(endpoints.logout, { refreshToken })
      .catch((error) => {
        console.error('Logout error:', error);
      })
      .finally(() => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');

        dispatch(logout());
        trackLogout();
        setIsDropdownOpen(false);
        navigate('/login');
      });
  };

  const handleProfileClick = () => {
    setIsDropdownOpen(false);
    navigate('/profile');
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <header className="bg-white px-4 md:px-6 py-2 flex justify-between items-center border-b border-gray-200 shadow-sm">
      <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
        <img src="/logo.png" alt="IndiePress" className="w-8 h-8 mr-2" />
        <span className="text-gray-900 text-lg md:text-xl font-semibold">
          IndiePress
        </span>
      </div>

      <div className="flex items-center gap-3 md:gap-4">
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={toggleDropdown}
            className="flex items-center gap-2 hover:bg-gray-50 rounded-lg px-2 py-1 transition-colors"
          >
            <div className="w-8 h-8 bg-gray-600 rounded-full flex items-center justify-center">
              <span className="text-white text-sm">{user?.name?.charAt(0).toUpperCase() || 'U'}</span>
            </div>
            <span className="text-gray-900 text-sm md:text-base hidden sm:inline">{user?.name || 'User'}</span>
            <ChevronDown className={`w-4 h-4 text-gray-600 hidden sm:block transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
          </button>

          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
              <button
                onClick={handleProfileClick}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Profile
              </button>
              <button
                onClick={handleLogout}
                className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors border-t border-gray-100"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
